
document.addEventListener('DOMContentLoaded', function () {

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          const img = entry.target;
          const srcset = img.getAttribute('data-srcset');
          const sizes = img.getAttribute('data-sizes');

          if (srcset) {
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-srcset');
          }

          if (sizes) {
            img.setAttribute('sizes', sizes);
            img.removeAttribute('data-sizes');
          }

          if (!img.complete) {
            img.addEventListener('load', function () {
              img.classList.add('is-loaded');
            }, { once: true });
          } else {
            img.classList.add('is-loaded');
          }

          obs.unobserve(img);
        });
      }, {
        root: null,
        rootMargin: '200px 0px',
        threshold: 0.01
      })
    : null;

  function initLazyImages(root = document) {
    const images = root.querySelectorAll('img.js-lazy-image');

    images.forEach(function (img) {
      if (img.dataset.lazyInitialized) return;

      img.dataset.lazyInitialized = 'true';

      if (observer) {
        observer.observe(img);
      } else {
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          img.removeAttribute('data-srcset');
        }

        if (img.dataset.sizes) {
          img.sizes = img.dataset.sizes;
          img.removeAttribute('data-sizes');
        }
      }
    });
  }

  // Initial page load
  initLazyImages();

  // Detect products added through infinite scrolling
  const mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches('img.js-lazy-image')) {
          if (!node.dataset.lazyInitialized) {
            initLazyImages(node.parentElement);
          }
        } else {
          initLazyImages(node);
        }
      });
    });
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

});
